import { useTerminalsState } from "@/States/Terminals";
import { useTrans } from "@/translations";

import { FilesView } from "./components/filesView";
import { PinnedMessageView } from "./components/pinnedMessageView";

export const LibraryV2: React.FC = () => {
  const { t } = useTrans();
  const { currentTerminal } = useTerminalsState();

  return (
    <div className="h-full min-h-[660px] w-full px-[33px] py-[44px]">
      <div className="font-signifier text-[44px] leading-[1.05] tracking-[-0.02em]">
        {t("libraryPage:pageTitle")}
      </div>
      <div className="font-dm-sans text-grey6 mt-2 text-[15px]">
        {t("libraryPage:pageDescription", {
          buildingName: currentTerminal?.name,
        })}
      </div>
      <PinnedMessageView />
      <FilesView />
    </div>
  );
};
